import React, { useState } from 'react';
import { TrendingUp, Clock, Award, Home, DollarSign, ChevronDown, ChevronUp } from 'lucide-react';
const evidenceMetrics = [{
  id: 1,
  label: 'Sale price vs market',
  value: '+5.2%',
  context: 'Sells homes for 5.2% above the 94109 average',
  icon: TrendingUp,
  badge: 'Top 6%'
}, {
  id: 2,
  label: 'Speed to close',
  value: '12 days',
  context: 'Faster than the local market median',
  icon: Clock,
  badge: 'Top 8%'
}, {
  id: 3,
  label: 'Market presence',
  value: '1 in 5',
  context: 'Homes sold in 94109 · 347 total',
  icon: Home,
  badge: 'Top 2%'
}, {
  id: 4,
  label: 'Total volume',
  value: '$285M',
  context: '18% of all volume in this ZIP',
  icon: DollarSign,
  badge: 'Top 1%'
}];
const deepDiveData = [{
  label: 'Sell-side transactions (24 mo)',
  value: '347'
}, {
  label: 'Buy-side transactions (24 mo)',
  value: '128'
}, {
  label: 'Median sale price',
  value: '$598K'
}, {
  label: 'ZIP median sale price',
  value: '$568K'
}, {
  label: 'Agent avg DOM',
  value: '18 days'
}, {
  label: 'ZIP median DOM',
  value: '30 days'
}, {
  label: 'Price range',
  value: '$425K — $4.2M'
}, {
  label: 'List-to-close conversion',
  value: '96.2%'
}];
export function PerformanceMetrics() {
  const [expanded, setExpanded] = useState(false);
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-107">
      <div className="mb-6" data-id="element-108">
        <h2 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-109">
          Performance in your neighborhood
        </h2>
        <p className="text-sm text-brand-muted max-w-2xl" data-id="element-110">
          All metrics shown relative to the local market in 94109 · San
          Francisco
        </p>
      </div>

      {/* Tier 2 — Evidence layer */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4" data-id="element-111">
        {evidenceMetrics.map(metric => {
        const Icon = metric.icon;
        return <div key={metric.id} className="bg-white px-4 py-4 rounded-xl shadow-premium border border-brand-light" data-id="element-112">
              <div className="flex items-center justify-between mb-3" data-id="element-113">
                <div className="w-8 h-8 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest" data-id="element-114">
                  <Icon size={16} data-id="element-115" />
                </div>
                <span className="text-[10px] font-medium text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full leading-tight border border-emerald-200" data-id="element-116">
                  {metric.badge}
                </span>
              </div>
              <h3 className="text-2xl font-mono text-brand-dark mb-1" data-id="element-117">
                {metric.value}
              </h3>
              <p className="text-xs text-brand-muted leading-snug" data-id="element-118">
                {metric.context}
              </p>
            </div>;
      })}
      </div>

      {/* Tier 3 — Deep dive (expandable) */}
      <button onClick={() => setExpanded(!expanded)} className="inline-flex items-center gap-1.5 text-sm text-brand-muted hover:text-brand-dark transition-colors" data-id="element-119">
        {expanded ? <ChevronUp size={16} data-id="element-120" /> : <ChevronDown size={16} data-id="element-121" />}
        {expanded ? 'Hide detailed data' : 'View detailed data'}
      </button>

      {expanded && <div className="mt-4 bg-white rounded-xl border border-brand-light p-5" data-id="element-122">
          <h3 className="text-sm font-medium text-brand-dark uppercase tracking-wider mb-4" data-id="element-123">
            Trailing 24-month detail
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6" data-id="element-124">
            {deepDiveData.map(item => <div key={item.label} data-id="element-125">
                <p className="text-xs text-brand-muted mb-0.5" data-id="element-126">{item.label}</p>
                <p className="font-mono text-sm text-brand-dark" data-id="element-127">
                  {item.value}
                </p>
              </div>)}
          </div>
        </div>}
    </section>;
}